import { createSlice } from '@reduxjs/toolkit';
import { allSteps, matchedStep, initialPlaceData, initialMainInfos, initialExtraInfos, initialLead } from './initialData';

export const initialState = () => {
  return {
    storeCreationTime: new Date(),
    funnelVersion: null,
    allSteps: allSteps['main'],
    currentStep: matchedStep(allSteps['main']),
    estimationData: {
      placeData: initialPlaceData,
      typology: null,
      mainInfos: initialMainInfos,
      extraInfos: initialExtraInfos,
      priceExpectations: '',
      waitingTimePeriod: null,
      nonSellingReason: null,
      lead: initialLead
    },
    errors: {},
    displayStreetNumberError: false
  }
};

export const estimationFunnelSlice = createSlice({
  name: 'estimationFunnel',
  initialState,
  reducers: {
    updateFunnelVersion(state, { payload }) {
      const funnelVersionChanged = (state.funnelVersion !== null && state.funnelVersion != payload.funnelVersion)
      
      if (funnelVersionChanged) {
        Object.assign(state, initialState())
      }
      state.funnelVersion  = payload.funnelVersion;      
      state.allSteps       = allSteps[payload.funnelVersion];
      state.currentStep    = funnelVersionChanged ? allSteps[payload.funnelVersion][0] : matchedStep(allSteps[payload.funnelVersion]);
    },
    updateStep(state, { payload }) {
      state.errors = {}
      state.currentStep = state.allSteps.find(step => step.number === payload.stepNumber);
    },
    updateEstimationData(state, { payload }) {
      state.estimationData = payload;
    },
    purgeEstimationData(state) {
      const initialPayload = { ...initialState(), allSteps: state.allSteps, currentStep: state.allSteps[0]}
      Object.assign(state, initialPayload);
    },
    updateFullStore(state, { payload }) {
      state.estimationData = payload;
    },
    updateErrors(state, { payload }) {
      state.errors = payload;
      if (payload.street_number) state.displayStreetNumberError = true;
    },
    updateDisplayStreetNumberError(state, { payload }) {
      state.displayStreetNumberError = payload;
    }
  },
})

export const { updateFunnelVersion, updateStep, updateEstimationData, purgeEstimationData, updateErrors, updateFullStore, updateDisplayStreetNumberError } = estimationFunnelSlice.actions;

export default estimationFunnelSlice.reducer;
